import { render, staticRenderFns } from "./service-regions.vue?vue&type=template&id=ce13dc90&"
import script from "./service-regions.vue?vue&type=script&lang=js&"
export * from "./service-regions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports